<template>
  <nav class="c-menuConversion m-menuHeader">
    <header-logo
      class="m-menuHeader_logo m-menuHeader_logo--startingTablet"
      :large-mode="true"
    />

    <div class="m-menuHeader_button m-menuHeader_button--burger m-menuHeader_button--untilTablet" @click="showMenuMobile()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" v-bind:svg-inline="''" v-bind:class="'m-menuHeader_icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#8e8e93"><path d="M0 0h20v3H0zM0 7h20v3H0zM0 14h20v3H0z"/></g></svg>
      <span class="m-menuHeader_text">menu</span>
    </div>

    <header-logo
      class="m-menuHeader_logo m-menuHeader_logo--untilTablet"
      :large-mode="true"
    />
    <div
      :class="expandedStyle('category')"
      @click="toggleMenu('category')"
      @keydown.enter="toggleMenu('category')"
      class="m-menuHeader_link m-menuHeader_link--startingTablet m-menuHeader_link--provider"
      role="button"
      tabindex="0"
      title="Qual serviço ou produto você precisa?"
    >
      <span class="m-menuHeader_text m-menuHeader_text--untilDesktop">Pedir orçamentos</span>
      <span class="m-menuHeader_text--startingDesktop">Pedir orçamentos</span>
      <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'m-menuHeader_icon m-menuHeader_icon--shop m-menuHeader_iconArrow'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.72 1.15L8 8.432l7.28-7.28L14.22.09 8 6.31 1.78.09.72 1.15z" fill="#000"/></svg>
    </div>

    <a class="m-menuHeader_link m-menuHeader_link--startingTablet m-menuHeader_link--provider" :href="supplierUrl">
      <span class="m-menuHeader_text" title="Veja os depoimentos de quem já usou o CoteiBem">Seja um fornecedor</span>
    </a>
  
    <a class="m-menuHeader_link m-menuHeader_link--startingTablet m-menuHeader_link--provider" :href="supportUrl">
      <span class="m-menuHeader_text" title="Problemas? Conte com a equipe do CoteiBem">FAQ</span>
    </a>
  
    <a
      class="m-menuHeader_button m-menuHeader_button--quotation"
      role="button"
      :href="loginUrl"
      tabindex="0"
    >
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'m-menuHeader_icon m-menuHeader_icon--shop'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 11.45a3.975 3.975 0 100-7.95 3.975 3.975 0 000 7.95zm2.475-3.975a2.475 2.475 0 11-4.95 0 2.475 2.475 0 014.95 0z" fill="#00665D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.87 19.707A10.49 10.49 0 0021.5 11C21.5 5.201 16.799.5 11 .5S.5 5.201.5 11A10.494 10.494 0 0011 21.5a10.471 10.471 0 005.87-1.793zM11 20a8.964 8.964 0 003.975-.923v-.393c0-2.333-1.732-4.159-3.975-4.159-2.242 0-3.975 1.826-3.975 4.16v.392A8.964 8.964 0 0011 20zm0-6.975c2.962 0 5.206 2.285 5.453 5.136a9 9 0 10-10.905 0c.246-2.851 2.49-5.136 5.452-5.136z" fill="#00665D"/></svg>
      <span class="m-menuHeader_text m-menuHeader_text--untilDesktop">Entrar</span>
      <span class="m-menuHeader_text--startingDesktop">Entrar</span>
    </a>
  </nav>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { account, landing, landingSupplier, categoryDirectory, categoryQuotation } from 'routes'
import { openModal } from 'Services/vueModal'
import slideoutExternal from 'Components/Header/Slideout/slideoutExternal'
import headerContainer from 'Components/Header/headerContainer'
import headerLogo from 'Components/Header/headerLogo.vue'

const initialState = () => ({
  categoryUrl: categoryDirectory.index,
  quoteUrl: categoryQuotation.index,
  loginUrl: account.login,
  supplierUrl: landingSupplier.index,
  supportUrl: landing.support,
})

export default {
  components: {
    headerLogo,
    headerContainer,
  },

  data() {
    return initialState()
  },

  computed: {
    ...mapState({
      selected: state => state.navigation.selected,
    }),
    categoryStyle() {
      return this.isExpanded('category')
        ? 'm-button--success'
        : 'm-button--successLight'
    }
  },

  methods: {
    ...mapActions({
      toggleMenu: 'navigation/toggleMenu'
    }),

    isExpanded(type) {
      const selected = this.selected[type]

      return typeof selected !== 'undefined' ? selected : false
    },

    expandedStyle(type) {
      return this.isExpanded(type)
        ? 'm-menuHeader_button--expanded'
        : ''
    },

    showMenuMobile() {
      openModal(this, slideoutExternal)
    },
  }
}
</script>

<style lang="scss">
@import "~css/_references";

.c-menuConversion {
  .m-menuHeader_logo {
    flex-grow: 1;
    margin-left: auto;

    @include f-media('>=tablet') {
      flex-grow: 0;
      margin-left: 0
    }
  }

  .m-menuHeader_link {
    @include f-media('>=desktopWide') {
      min-height: 0;
      padding: $v-gap-sm;

      &:hover {
        background: transparent;
        color: #000;
      }
    }
    @include f-media('>desktop', '<desktopMedium') {
      padding: $v-gap-sm 14px;
    }
  }

  .m-menuHeader_text {
    color: #000;
    @include f-media('>=desktopWide') {
      font-size: 16px;
      padding: 0;
    }
  }

  .m-menuHeader_iconArrow {
    margin-left: 12px;
    margin-right: 0;
    width: 14.56px;
    height: 8.34px;
  }

  .m-menuHeader_button--quotation {
    color: #00665D;
    fill: #00665D;
    @include f-media('>=tablet') {
      border-color: #00665D;
      }
    @include f-media('>=desktopWide') {
      height: 50px;
      padding: $v-gap-xxs $v-gap-sml;
      font-weight: $v-fontWeight-semibold;
      max-width: 107px;
    }
  }

  @include f-media('>=desktopWide') {
   .m-menuHeader_button--expanded::before {
      bottom: -14px !important;
      left: 85%;
    }
  }

  @include f-media('>=tablet', '<desktop') {
    .m-menuHeader_link {
      &--provider {
        display: none;
      }
    }
    .m-menuHeader_button--expanded::before {
      display: none;
     }
  }

  .m-menuHeader_button--expanded::before {
    bottom: -14px;
    left: 85%;
  }
}
</style>